/*
	Footer component
*/

<template>
	<div>
		<h1>Basic footer</h1>
	</div>

</template>

<script>
	export default {
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// Footer.vue?443ad10d